import React from "react";
import ReactDOMServer from "react-dom/server";

export function ComponentToString(Component, props) {
  return ReactDOMServer.renderToString(<Component {...props} />);
}
